const getFieldValue = (source, ...keys) => {
    if (!source) return '';

    const match = keys.find((key) => source[key] !== undefined && source[key] !== null && source[key] !== '');
    return match ? source[match] : '';
};

export const getCountryFlagSrc = (country) => {
    const countryFlagPath = getFieldValue(country, 'countryFlagPath', 'CountryFlagPath', 'flagPath', 'FlagPath');
    const countryAbbr = getFieldValue(country, 'countryAbbr', 'CountryAbbr', 'abbr', 'Abbr', 'countryCode', 'CountryCode');
    const fallbackPath = countryAbbr ? `/assets/flags/${String(countryAbbr).trim().toUpperCase()}.png` : '';
    const path = countryFlagPath || fallbackPath;

    if (!path || typeof path !== 'string') return '';

    const trimmed = path.trim();
    if (!trimmed || /^(https?:|data:|blob:)/i.test(trimmed)) return trimmed;

    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const getCountryFlagAlt = (country) =>
    getFieldValue(country, 'countryName', 'CountryName', 'countryDescr', 'CountryDescr', 'name', 'Name') ||
    getFieldValue(country, 'countryAbbr', 'CountryAbbr', 'abbr', 'Abbr', 'countryCode', 'CountryCode') ||
    '';
